module.exports = __webpack_public_path__ + "img/hell-cat-ears.bb71340f.png";